import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledProductPrice = styled.div`
  > .frequency {
    font-weight: 400;
  }
`;

const ProductPrice = ({
  currency, price, frequency,
}) => (
  <StyledProductPrice className="ProductPrice">
    <span>{price.toLocaleString(navigator.language, { style: 'currency', currency })}</span>
    {frequency && (
      <span className="frequency">
        /
        {frequency}
      </span>
    )}
  </StyledProductPrice>
);

ProductPrice.displayName = 'ProductPrice';

ProductPrice.propTypes = {
  currency: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  frequency: PropTypes.string,
};

ProductPrice.defaultProps = {
  frequency: undefined,
};

export default ProductPrice;
